// Lista local de países (pt-BR). Substitui a chamada externa a restcountries.com,
// que falhava com CORS de forma intermitente e quebrava o console da edição de contato.
const countries = [
	"Afeganistão", "África do Sul", "Albânia", "Alemanha", "Andorra", "Angola",
	"Antígua e Barbuda", "Arábia Saudita", "Argélia", "Argentina", "Armênia",
	"Austrália", "Áustria", "Azerbaijão", "Bahamas", "Bahrein", "Bangladesh",
	"Barbados", "Bélgica", "Belize", "Benin", "Bielorrússia", "Bolívia",
	"Bósnia e Herzegovina", "Botsuana", "Brasil", "Brunei", "Bulgária",
	"Burkina Faso", "Burundi", "Butão", "Cabo Verde", "Camarões", "Camboja",
	"Canadá", "Catar", "Cazaquistão", "Chade", "Chile", "China", "Chipre",
	"Cingapura", "Colômbia", "Comores", "Congo", "Coreia do Norte",
	"Coreia do Sul", "Costa do Marfim", "Costa Rica", "Croácia", "Cuba",
	"Dinamarca", "Djibuti", "Dominica", "Egito", "El Salvador",
	"Emirados Árabes Unidos", "Equador", "Eritreia", "Eslováquia", "Eslovênia",
	"Espanha", "Estados Unidos", "Estônia", "Eswatini", "Etiópia", "Fiji",
	"Filipinas", "Finlândia", "França", "Gabão", "Gâmbia", "Gana", "Geórgia",
	"Granada", "Grécia", "Guatemala", "Guiana", "Guiné", "Guiné-Bissau",
	"Guiné Equatorial", "Haiti", "Honduras", "Hungria", "Iêmen", "Ilhas Marshall",
	"Ilhas Salomão", "Índia", "Indonésia", "Irã", "Iraque", "Irlanda",
	"Islândia", "Israel", "Itália", "Jamaica", "Japão", "Jordânia", "Kiribati",
	"Kosovo", "Kuwait", "Laos", "Lesoto", "Letônia", "Líbano", "Libéria",
	"Líbia", "Liechtenstein", "Lituânia", "Luxemburgo", "Macedônia do Norte",
	"Madagascar", "Malásia", "Malaui", "Maldivas", "Mali", "Malta", "Marrocos",
	"Maurício", "Mauritânia", "México", "Mianmar", "Micronésia", "Moçambique",
	"Moldávia", "Mônaco", "Mongólia", "Montenegro", "Namíbia", "Nauru", "Nepal",
	"Nicarágua", "Níger", "Nigéria", "Noruega", "Nova Zelândia", "Omã",
	"Países Baixos", "Palau", "Palestina", "Panamá", "Papua-Nova Guiné",
	"Paquistão", "Paraguai", "Peru", "Polônia", "Portugal", "Quênia",
	"Quirguistão", "Reino Unido", "República Centro-Africana",
	"República Democrática do Congo", "República Dominicana", "República Tcheca",
	"Romênia", "Ruanda", "Rússia", "Samoa", "San Marino", "Santa Lúcia",
	"São Cristóvão e Névis", "São Tomé e Príncipe", "São Vicente e Granadinas",
	"Seicheles", "Senegal", "Serra Leoa", "Sérvia", "Síria", "Somália",
	"Sri Lanka", "Sudão", "Sudão do Sul", "Suécia", "Suíça", "Suriname",
	"Tailândia", "Taiwan", "Tajiquistão", "Tanzânia", "Timor-Leste", "Togo",
	"Tonga", "Trinidad e Tobago", "Tunísia", "Turcomenistão", "Turquia",
	"Tuvalu", "Ucrânia", "Uganda", "Uruguai", "Uzbequistão", "Vanuatu",
	"Vaticano", "Venezuela", "Vietnã", "Zâmbia", "Zimbábue"
];

export default countries;
